export const BETA_FEATURE_WHATSAPP = 'tracking_messages_whatsapp'
